// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_app_seo_description = /** @type {(inputs: {}) => string} */ () => {
	return `MochiMemo is a Japanese language learning platform that adapts to your progress`
};

const id_app_seo_description = /** @type {(inputs: {}) => string} */ () => {
	return `MochiMemo adalah platform pembelajaran bahasa Jepang yang beradaptasi dengan kemajuan Anda`
};

const ja_app_seo_description = /** @type {(inputs: {}) => string} */ () => {
	return `MochiMemoはあなたの進歩に合わせて適応する日本語学習プラットフォームです`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const app_seo_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.app_seo_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("app_seo_description", locale)
	if (locale === "en") return en_app_seo_description(inputs)
	if (locale === "id") return id_app_seo_description(inputs)
	return ja_app_seo_description(inputs)
};
export { app_seo_description as "app.seo_description" }